/**
 * Extend Marb namespace
 */
try {
	Marb.extend({
		Installation : (function() {
			var initialize = function(data) {
				var INSTALLATION_CALENDAR = data.INSTALLATION_CALENDAR;
				var PRODUCTS = data.PRODUCTS;
				var DISCOUNT = data.DISCOUNT;
				var trackResult = data.trackResult;
				var itId = data.itId;
				var isReseller = data.isReseller;
				var is365 = data.is365;
				var showInstallationTypes = data.showInstallationTypes;
				var isSpecialBudget = data.isSpecialBudget;
				var isSbAccessed = data.isSbAccessed;
				
				$("#tabs").tabs();
				
				$(".calendar-img").click(function(){
					$("#" + $(this).data("bind")).datepicker( "show" );
				});
				
				$('.show-login-btn').on('click', function(){
					Marb.Components.LoginPopup.show({
						onSuccess: function(){							
							var href = document.location.href.split('?');
							var url = href[0] + '/login';
							if( href.length > 1 ){
								url += '?' + href[1];
							}
							var form = $('#installation-form').clone();
							form.attr('action', url);
							form.submit();
							window.location.reload();
						}
					});
				});
				
				
				if(!isSpecialBudget){				
				
					$("#when").datepicker({
						showOtherMonths: true,
			            selectOtherMonths: true,
			    		buttonImage: "/static/images/ico_calendar.png",
			    	    buttonImageOnly: true,
			    	    dateFormat: "dd/mm/yy",
			    	    minDate: 0,
			    	    beforeShowDay: installationDateCheck,
			    	    onClose: function(dateTxt, inst){
			    	    	$("#when").valid();
				    	    doCheckTime(dateTxt);
			    	    }
			    	});			
					
					jQuery.validator.addMethod(
				   		    "otherInputNotEmpty",
				   		    function(value,element,params) {
				   		    	if( ! $(params).val() ){
				   		    		return false;
				   		    	}
				   		        return true;
				   		    },
				   		    ""
				   		);
					
					jQuery.validator.addMethod(
				   		    "addressWithNumber",
				   		    function(value,element,params) {
				   		    		return /\d/.test(value);
				   		    },
				   		    ""
				   		);
				    	
			    	$.validator.messages.required = "";
			    	$.validator.messages.latinDate = "";
			    	$.validator.messages.min = "";
			    	$.validator.messages.max = "";
			    	$.validator.messages.email = "";
			    	$.validator.messages.equalTo = "";
			    	$.validator.messages.addressWithNumber = $.i18n.prop('p.createjob.location.address.incomplete');
				    	
				   	Marb.Validate.init({
			    		debug: true,
						formId: 'installation-form',
						options:
							{rules:
								{
								"citytxt": {
			        				"otherInputNotEmpty": "#city"
			        				},
			        			city: {
				        				required: true
				        			},
				        		when: {
				        				latinDate: true
				        			}, 
								"productInstallationId" : { required: true, min: 1},
								"brand" : { required: true, min: 0},
								"installationTypeId" : { required: true, min: 1},
								"cep-br" : { required: true},
								"addressLine" : { 
									required: true,
									addressWithNumber: true}
								}
							}
					});
				   	
				   	Marb.Geo.setCityAutocomplete({
						textId: 'city-search-text',
						valueId: 'city',
						filter: 'leaf',
						textWatermark: $.i18n.prop('p.createjob.location.watermark'),
						trackResult: trackResult
					});
				   	
				   	$("#cep-br").mask("99999999",{placeholder:"_"});
				   	
				   	$("#cep-br").focusout(function () {
				   		var inputValue = $("#cep-br").val().replace(/_/g, '');
				   		if ($.isNumeric(inputValue)  && inputValue.length == 8){
							$.getJSON(
								"/geo/cep/"+inputValue,
								function(response) {
									if (!response.success){
										Marb.Page.Toast.error({'text': $.i18n.prop('p.toast.cep.error')});	
										return;
									}
			    					$("#addressLine").val($.trim(response.data.cep.street.streetType + ' '+ response.data.cep.street.streetName));
			    					$("#city-search-text").val(response.data.cep.locationDetail);
			    					$("#city-search-text").data('lastuniquevalue',response.data.cep.locationDetail);
			    					$("#city").val(response.data.cep.locationId);
			    					$("#city").data('lastuniquevalue',response.data.cep.locationId);
			    					//force update of city
			    					$("#city").change();
			    					if(!response.data.cep.locationDetail){
			    						Marb.Page.Toast.error({'text': 'Região não atendida'});
										return;
			    					}
							});
				   		}else{
				   			Marb.Page.Toast.error({'text': $.i18n.prop('p.toast.cep.invalid.error')});
				   		}
				   	});
				}

                $('#corpSiteId').on('change', function(){
                    var city = $('#corpSiteId option:selected').data('city');
                    $('#city').val(city).change();
                });

		    	$('#city, #productInstallationId, select[name="addOnsIds"]').on('change', function(){
		    		updateCalendar();
		    		recalculatePrice();
		    	});
		    	
		    	Marb.Commons.Utils.onlyIntegers('#units');
			
		    	function updateCalendar(){
		    		if( Marb.Commons.Utils.isBlank($('#city').val()) || isSpecialBudget	){
		    			return;
		    		}
		    		var pids = getSelectedProductIds();
		    		var previousOrderId = getPreviousOrderIdIfPresent();
		    		$.getJSON('/job-installation/calendar', 
		    			{loc: $('#city').val(), iTypeId: $('#installationTypeId').val(), pids: pids, orderId: previousOrderId},
		    			function(response){
		    				if( response.success && response.data.calendar){
		    					INSTALLATION_CALENDAR = response.data.calendar;
		    				}else{
		    					INSTALLATION_CALENDAR = {};
		    				}
		    				doCheckTime($('#when').val());
		    			}
		    		);
		    	}
		    	
		    	function getSelectedProductIds(){
		    		var addOns = $('#productInstallationId, select[name="addOnsIds"]').map(
		    				function(){
		    					var val = $(this).val();
		    					return val > 0 ? val : null;
		    				}
		    			).get()
		    			.join();
		    		
		    		return addOns;
		    	}
		    	
		    	function getPreviousOrderIdIfPresent(){
		    		var orderId = 0;
		    		if( $('#orderId').length > 0 ){
		    			orderId = $('#orderId').val();
		    		}
		    		
		    		return orderId;
		    	}
		    	
		    	function doCheckTime(dateTxt){
		    		if(dateTxt.length != 10 ){
		    			return;
		    		}
		    		var pi = $('#productInstallationId option:selected');
		    		var isOnDemand = pi.data('ondemand');
		    		if( isOnDemand ){
		    			return;
		    		}
		    		var parts = dateTxt.split("/");
	    	    	var key = parts[2] + "/" + parts[1] + "/" + parts[0];
	    	    	var cal = INSTALLATION_CALENDAR[key];
	    	    	if( cal ){
	    	    		for(var i in cal.availableOn){
	    	    			if( cal.availableOn[i] ){
		    	    			$('#timeRange option[value='+i+']').attr('disabled', null);
		    	    		}else{
		    	    			$('#timeRange option[value='+i+']').attr('disabled', true);
		    	    		}
	    	    		}
	    	    		$($('#timeRange option:enabled')[0]).attr('selected', true);
	    	    	}else{
	    	    		$('#timeRange option').attr('disabled', null);
	    	    		$('#when').val('');
	    	    	}
		    	}
		    	
				function installationDateCheck(date) {		
						var dayFormatted = Marb.Commons.Utils.formatDateyyyyMMdd(date);
						var da = INSTALLATION_CALENDAR[dayFormatted];
						var ret = {};
						if( da ){
							ret[0] = true;
							ret[1] = '';
							ret[2] = '';
						}else{
							ret[0] = false;
							ret[1] = '';
							ret[2] = $.i18n.prop('p.customer.job.installation.create.date.unavailable');
						}
						return ret;
				};
				
				$("#installationTypeId").on("change", onInstallationTypeIdChange);				
				
		    	
		    	$('#termsViewAll').on('click', showAllTerms);    	
				
				
		    	
		    	$("#brand").on("change", function(){
		    		loadProducts();
		    		autoSelectUniqueOption('#productInstallationId');
		    	});
		    	
		    	$("#productInstallationId").on("change", function(){
		    		var _this = $(this);
		    		var option = _this.find("option:selected");
		    		$("#subCategoryId").val(option.data("subcategoryid"));
		    		var showAmount = option.data('showamount');
		    		var minAmount = option.data('minamount');
		    		var maxAmount = option.data('maxamount');
		    		var isVisit = option.data('visit');
		    		var isOnDemand = option.data('ondemand');
		    		var currentAmount = $('#units').val();
		    		var unitPrice = option.data('varprice');
		    		var fixedPrice = option.data('fixedprice');
		    		var customPrice = option.data('customprice');
		    		if( ! customPrice ){
		    			if( currentAmount < minAmount ){
		    				$('#units').val( minAmount );
		    			}else if( currentAmount > maxAmount ){
		    				$('#units').val( maxAmount );
		    			}
		    		}
		    		if( showAmount ){
		    			$('.field.units').show();
		    		}else{
		    			$('.field.units').hide();
		    		}
		    		loadUnits();
		    		$('#price-visit-text').hide();
		    		if( _this.val() > 0 ){
		    			$('.price-tooltip').hide();
		    			recalculatePrice();
		    			if( isVisit == true && (unitPrice + fixedPrice) > 0){
		    				$('#price-visit-text').show();
		    			}
		    		}else{
		    			hidePrice();
		    		}
		    		if( isOnDemand ){
		    			$('#onDemand-container').show();
		    			$('#date-container').hide();
		    			$('#when').val('01/01/1970');
		    		}else{
		    			$('#date-container').show();
		    			$('#onDemand-container').hide();
		    			$('#when').val('');
		    		}
		    	});
		    	
		    	$("#units").on("change", function(){
		    		console.log('entered units');
		    		var pi = $('#productInstallationId option:selected');
		    		if( ! pi.data('customprice') ){
			    		var minAmount = pi.data('minamount');
			    		var maxAmount = pi.data('maxamount');
			    		var value = $(this).val();
			    		if( ! value || value < minAmount ){
			    			$(this).val(minAmount);
			    		}else if( value > maxAmount ){
			    			$(this).val(maxAmount);
			    		}
		    		}
		    		recalculatePrice();
		    	});
		    	
		    	function validateDiscounts(){
		    		if (Marb.Commons.Utils.isBlank($('#city').val())){
		    			M.Page.Toast.error({text: $.i18n.prop('p.customer.job.installation.create.form.location.required')});
		    			return false;
		    		}
		    		
		    		return true;
		    	}
		    	
		    	$('#check-coupon').on('click', function(){
		    		
		    		var code = $('#couponCodeCheck').val();
		    		if( ! code  || !validateDiscounts()){
						$('#couponCodeCheck').focus();
						return;
					}
		    		
		    		code = code.toUpperCase();
		    		$.getJSON('/job-installation/coupon/check', 
		    			  {
		    				'itid': itId,
		    				'ipid': $('#productInstallationId').val(),
		    				'cc': code
		    			  }, 
		    			  function(response){
		    				if( response.success && response.data.available ){
		    					DISCOUNT = response.data.pricing;
		    					DISCOUNT['text'] = response.data.text;
		    					$('#couponCodeCheck').hide();
		    					$('#check-coupon').hide();
		    					
		    					$('#couponCode').val(code);
		    					$('#checked-coupon').text(code);
		    					$('#coupon-applied').show();
		    					recalculatePrice();
		    				}else{
		    					M.Page.Toast.error({text: $.i18n.prop('p.customer.job.installation.create.form.couponCode.invalid')});
		    				}
		    			  }
		    		);
		    	});
		    	
		   		$('#check-membership').on('click', function(){    		
		    		var membershipNumber = $('#365CodeCheck').val();
		    		if( ! membershipNumber || !validateDiscounts()){
						$('#365CodeCheck').focus();
						return;
					}
		    	
		    		$.getJSON('/job-installation/365membership/check', 
		    			  {
		    				'itid': itId,    			
		    				'membership': membershipNumber
		    			  }, 
		    			  function(response){
		    				if( response.success && response.data.available ){
		    					DISCOUNT = response.data.pricing;
		    					DISCOUNT['text'] = response.data.text;
		    					$('#365CodeCheck').hide();
		    					$('#check-membership').hide();   
		    					$('#checked-membership').text(membershipNumber);
		    					$('#membership-applied').show();		    				
		    					recalculatePrice();
		    					$('#membership-applied-icon').show();
		    					$('#coupon-applied-text').hide();
		    					$('#coupon-applied-icon').hide();
		    					
		    				} else if (!response.data.isMember){
		    					M.Page.Toast.error({text: $.i18n.prop('p.customer.job.installation.create.form.365member.invalid')});
		    				} else {
		    					M.Page.Toast.error({text: $.i18n.prop('p.customer.job.installation.create.form.365member.noCoupon')});
		    				}
		    			  }
		    		);
		    	});
		   	
		    	if( $('#couponCodeCheck').val() ){
		    		$('#check-coupon').click();
		    	}
		    	
		    	$('#show-more-services').on('click', function(){
		    		var idx = $(this).data('idx');
		    		if( ! idx ){
		    			idx = 1;
		    		}
		    		$(this).data('idx', idx+1);
		    		var addOn = $('#add-on-template').clone();
		    		addOn.attr('id', 'add-on-item' + idx);
		    		addOn.removeClass('hidden');
		    		addOn.find('.typeIds').addClass("extra-service");
		    		loadAddOnCombos(addOn);
		    		
		    		$('#add-ons-container').append(addOn);
		    		
		    		Marb.Commons.Utils.onlyIntegers('#add-on-item'+idx+' .value');
		    	});
		    	
		    	if( !showInstallationTypes){
		    		onInstallationTypeIdChange();
			    	$('#installationTypeContainer').css('display', 'none');
			    	if( Marb.Commons.Utils.isFullScreen() ){
			    		$('#serviceName').css('display', 'block');
			    	}
				} else {
					$('#serviceName').css('display', 'none');
				}
	    
		    	Marb.Commons.Utils.accordion({selector:'.accordion'});
		    	

		    	initializeCombos(PRODUCTS);

		    	
		    	
		    	if(!isSpecialBudget){		    		
			    	
			    	if( Marb.Commons.Utils.isFullScreen()  ){
						Marb.Commons.Utils.lockInViewport({
							selector: '#floatingFaq',
							reference: '#priceContainerFixed',
							maxScrollV: '.footer .btn-submit',
							maxScrollVDelta: parseFloat($('#payOnline').css('height'),10)
						});
						Marb.Commons.Utils.lockInViewport({
							selector: '#priceContainerFixed',
							maxScrollV: '#floatingFaq',
							maxScrollVDelta: -20
						});
					}else{
						Marb.Commons.Utils.lockInViewport({
							selector: '#priceContainerFixed .product-price'
						});
					}
			    	
			    	if($("#registration-username").length > 0 && !isReseller) {
				    	$("#registration-username").rules('add', { 
				    		remote: {
				    			url: "/email-check",
				    			type: "get",
				    			data: {
				    	          username: function() {
				    	            return $("#registration-username").val();
				    	          }
				    	        }
				    		},
				    		messages: {			    		
				    			remote:	$.i18n.prop('p.customer.job.installation.create.user.alreadyExists')
				    		}
				    	});
			    	};
			    	
			    	if(!isReseller) {
				    	$('#registration-username, #phone').on('change', function(){
				    		$.post('/job-installation/new-contact', $('#installation-form').serialize(), function(){});
				    	});
			    	}
		    	}
		    	if(is365){
		    	  $("#tabs").tabs('option', 'active',1);
		    	}
		    	
				function loadBrands() {
					var _this = $("#installationTypeId");
					var brands = {};
					for(var installationTypeKey in PRODUCTS) {
						if(installationTypeKey == _this.val()) {
							for(var productKey in PRODUCTS[installationTypeKey]) {
								if(!PRODUCTS[installationTypeKey].hasOwnProperty(productKey)) continue;
								var iProduct = PRODUCTS[installationTypeKey][productKey];
								brands[iProduct.product.brand.id] = iProduct.product.brand.name;
							}	
						}
					}
					var html = getGenericOption($.i18n.prop('p.customer.job.installation.create.form.product.brand.chooseOne'));
					for(var brandKey in brands) {
						html += "<option value='" + brandKey +"'>" + brands[brandKey] + "</option>";
					}
					var brandCombo = $("#brand");
					brandCombo.html(html);
					var brandCount = brandCombo.children().length;
					if( brandCount > 2){
						$('.field.brand').show();
						hidePrice();
					}else{
						$('.field.brand').hide();
						if( brandCount == 1){
							hidePrice();
						}
					}
					
					loadProducts();
					autoSelectUniqueOption('#brand');
					autoSelectUniqueOption('#productInstallationId');
				}
				
				function loadProducts() {
					var _this = $(this);
					var installationTypeId = $("#installationTypeId").val();
					var brandId = $("#brand").val();
					var products = {};
					for(var installationTypeKey in PRODUCTS) {
						if(installationTypeKey == installationTypeId) {
							for(var productKey in PRODUCTS[installationTypeKey]) {
								if(!PRODUCTS[installationTypeKey].hasOwnProperty(productKey)) continue;
								var iProduct = PRODUCTS[installationTypeKey][productKey];
								if(! iProduct.addOn && iProduct.product.brand.id == brandId) {
									products[iProduct.id] = iProduct;
								}
							}	
						}
					}
					var html = getGenericOption($.i18n.prop('p.customer.job.installation.create.form.product.product.chooseOne'));
					for(var productKey in products) {
						var product = products[productKey];
						html += "<option value='" + productKey +"' data-fixedprice='"+product.fixedResellerPricing+"' data-varprice='"+product.variableResellerPricing+"' data-customprice='" + product.customPrice + "' data-subcategoryid='"+ product.installationType.subcategoryId +"' data-showamount='"+product.showAmount+"' data-minamount='"+ product.minAmount +"' data-maxamount='"+ product.maxAmount +"' data-visit='"+product.visit+"' data-withouttax='" + product.withoutTax + "' data-ondemand='"+product.onDemand+"' data-units='"+ product.unitName+"' >" + products[productKey].product.model + "</option>";
					}
					var productCombo = $("#productInstallationId");
					productCombo.html(html);
					var productCount = productCombo.children().length;
					if( productCount > 2 ){
						$('.field.product').show();
						hidePrice();
					}else{
						$('.field.product').hide();
						if( productCount == 1 ){
							hidePrice();
						}
					}
					
				}

                function getAllTerms(termsIncludedFirst) {
                    var installationTypeSelected = $("#installationTypeId").find("option:selected");
                    var terms = installationTypeSelected.data("terms");
                    var termsIncluded = installationTypeSelected.data("termsincluded");
                    var termsNotIncluded = installationTypeSelected.data("termsnotincluded");

                    var allTerms;
                    if (termsIncludedFirst) {
                        allTerms = termsIncluded + "\n" + terms + "\n" + termsNotIncluded;
                    } else {
                        allTerms = terms + "\n" + termsIncluded + "\n" + termsNotIncluded;
                    }
                    return allTerms;
                }
				
				function loadTerms() {
                    $("#specific-terms").html(termsFirstStrToHtml(getAllTerms(true)));
				}
				
				function loadUnits(){
					var units = $("#productInstallationId").find("option:selected").data("units");
					$('#installation-units').text( units );
				}

				function showAllTerms(){
                    var allTerms = getAllTerms().split("\n");
					var htmlTerms = "<ul id='fullTermsPopUp' class='job-installation-create all-terms scrollable'>";
                    for (var i = 0; i < allTerms.length; i++) {
                        var term = allTerms[i];
                        if (allTerms.length > 0) {
							htmlTerms += "<li>" + term + "</li>";
						}
					}
					htmlTerms += "</ul>";
					
					Marb.Components.Confirm.openSimple({
						title: $.i18n.prop('p.customer.job.installation.create.form.terms.title'),
						bodyHtml: htmlTerms,
						showCancel: false
					});
					Marb.Page.scrollables('#fullTermsPopUp');
				}
				
				function termsFirstStrToHtml(termsStr) {
			    	var html = "";
					if(termsStr) {
			    		var termsA = termsStr.split("\n");
			    		//show only first term now.
			    		for(var i = 0; i < 1; i++) {
			    			html += termsA[i];
			    		}
			    	}
					return html;
				}
				
				
				
				function getGenericOption(msg) {
					return '<option value="0">'+msg+'</option>';
				}
				
				function initializeCombos(PRODUCTS) {
					$("#installationTypeId").val(itId);
					$("#installationTypeId").change();
			    	
			    	autoSelectUniqueOption('#installationTypeId');
			    	//if the product was already selected by querystring AND the value actually exists
			    	var pid = Marb.Commons.Utils.getParameterByName('pi');
			    	if( pid && pid != 0 ){
			    		var paramProduct = null;
			    		for(var i = 0; i < PRODUCTS[itId].length; i++) {
							var temp = PRODUCTS[itId][i];
							if( temp && temp.id == pid){
								paramProduct = temp;
								break;
							}
						}
			    		if( paramProduct != null ){
			    			$('#brand').val(paramProduct.product.brand.id);
			    			$('#brand').change();
			    			$('#productInstallationId').val(pid);
			    			$('#productInstallationId').change();
			    		}
			    	}
			    	
			    	$('#userWithoutEmail').on('click', function(){
			    		if( $(this).is(':checked') ){
			    			$('#registration-username').addClass('disabled');
			    			$('#registration-username').val('no@email.com');
			    			$('#noEmailWarning').show();
			    		}else{
			    			$('#registration-username').removeClass('disabled');
			    			$('#registration-username').val(null);
			    			$('#noEmailWarning').hide();
			    		}
			    	});
			    	
				}
				
				function autoSelectUniqueOption(selectId){
					var count = $(selectId).children().size();
			    	if( count >= 2 && $(selectId).val() < 1){
						$(selectId).children()[1].selected=true;
						$(selectId).change();
			    	}
				}
				
				function showFinalPrice(regularPrice, price, withoutTax){
					if( price >= 0 ){
						var text="";						
	//					FIXME this logic only works if the coupon applies for all products
	//					in the order. If not the price will differ from the calculated in
	//					the server						
						if( DISCOUNT ){
							if( DISCOUNT.pricingType == 'FIXED_DISCOUNT_PCT'){
								if( price > DISCOUNT.minPriceCap ){
									var discount = Math.min(DISCOUNT.maxDiscountAmount, price * DISCOUNT.amount / 100);
									price = Math.max(DISCOUNT.minPriceCap, price - discount) ;
								}
							}else if( DISCOUNT.pricingType == 'FIXED_DISCOUNT_ABSOLUTE'){
								if( price > DISCOUNT.minPriceCap ){
									price = Math.max(DISCOUNT.minPriceCap, price - DISCOUNT.amount );
								}
							}else if( DISCOUNT.pricingType == 'FIXED_PRICE'){
								price = DISCOUNT.amount;
							}
							text = DISCOUNT.text;
						}
						showPrice(regularPrice, price, text, withoutTax);
					}
				}
				
				function recalculatePrice(){
					if(!isSbAccessed){
						var selectedPi = $("#productInstallationId option:selected");
			    		if( Marb.Commons.Utils.isBlank($('#city').val()) || selectedPi.data('customprice')){
							var units = $('#units').val();
							var unitPrice = selectedPi.data('varprice');
							var fixedPrice = selectedPi.data('fixedprice');
							var mainPrice = 0;
							if( selectedPi.data('customprice') ){
								mainPrice = $('#units').unmask()/100;
							}else{
								mainPrice = fixedPrice/100 + (units * unitPrice / 100 );
							}
							var price = mainPrice + getAddOnsPrice();
							var withoutTax = $("#productInstallationId option:selected").data('withouttax');
							var regularPrice = price;
							showFinalPrice(regularPrice, price, withoutTax);
			    		}else{
			    			$.getJSON('/productInstallation/pricing', 
			    					{
			    				locationCode: $('#city').val(),
			    				productIds: $.unique($("#productInstallationId :selected,.productIds :selected").map(function(){return this.value;}).get().sort()).sort().join(),
			    					},
			    					function(response){
			    						if( response.success && response.data.pricing){
			    							var units = $('#units').val();
			    							var unitPriceMap = response.data.pricing;
			    							var unitPrice = unitPriceMap[$("#productInstallationId").val()];
			    							var price = unitPrice.fixedResellerPriceInCents + units * unitPrice.variableResellerPriceInCents / 100 + getAddOnsPrice(unitPriceMap);
			    							var regularPrice = price;
			    							var withoutTax = unitPrice.withoutTax;
			    							showFinalPrice(regularPrice, price, withoutTax);
			    						}
			    					}
			    			);
			    			
			    		}
					}
		    		
				}
				
				function getAddOnsPrice(unitPriceMap){
					var products = $('#add-ons-container .add-on');
					var price = 0;
					products.each(function(idx, elem){
						var parent = $(elem);
						var product = parent.find('.productIds :selected');
						if( product.length == 0 ){
							return;
						}
						if( product.val() < 1 ){
							return;
						}
						var units = parent.find('.units .value').val();
						if( units < 1 ){
							return;
						}
						
						var unitPrice;
						var fixedPrice;
						if (unitPriceMap){
							var unitPricing = unitPriceMap[product.val()];
							unitPrice = unitPricing.variableResellerPriceInCents;
							fixedPrice = unitPricing.fixedResellerPriceInCents;
						}else{
							unitPrice = product.data('varprice');
							fixedPrice = product.data('fixedprice');
						}
						price += (units * unitPrice /100) + fixedPrice/100;
					});
					return price;
				}
				
				function showPrice(regularPrice, discountedPrice, text, withoutTax){
					var regularFormatted = Marb.Commons.Utils.formatCurrency(regularPrice);
					if( regularPrice != discountedPrice){
						var discountedFormatted = Marb.Commons.Utils.formatCurrency(discountedPrice) ;
						$('#product-price-value').text( regularFormatted );
						$('.product-price .original-price').addClass('crossed');
						$('#product-discounted-price-value').text( discountedFormatted );
						$('#coupon-applied-icon').attr('title', text);
						if(regularPrice > 1000 && discountedPrice > 1000 ){
							//if price is too high then design breaks
							//so hide the coupon text
							
							$('#coupon-applied-text').html('');
						}else{
							$('#coupon-applied-text').html(text);
						}
						$('#product-discounted-price-value-container').show(400);
					}else{
						$('#product-price-value').text( regularFormatted );
						$('.product-price .original-price').removeClass('crossed');
						$('#product-discounted-price-value-container').hide();
					}
					
					if(withoutTax){
						$("#product-price-plusTax").show();
					}
				}
				
				function hidePrice(){
					if( gJiInited ){
						$('.price-tooltip').show();
					}
					if(!isSbAccessed){
						$('#product-price-value').text('');
					}
				}
				
//				 Add ons Functions
				function loadAddOnCombos(addOn){
					var typeIdsHtml = $('#installationTypeId').html();
					var typeIds = addOn.find('.typeIds');
					typeIds.html(typeIdsHtml);
					typeIds.on('change', function(){loadAddOnProducts(typeIds);});

					var productIds = addOn.find('.product .productIds');
					productIds.on('change', function(){ chooseAddOnProduct(productIds); });
					
					var unitsValue = addOn.find('.units .value');
					unitsValue.on('change', function(){ updateAddOnPrice(unitsValue); });
				}
				
				
				function loadAddOnProducts(typeIds){
					var parent = typeIds.closest('.add-on');
					var installationTypeId = typeIds.val();
					var products = {};
					var type = typeIds.find(':selected');
					typeIds.hide();
					var deleteMe = $('<i class="delete text-m link">x</i>');
					deleteMe.on('click', function(){
						$(this).closest('.add-on').remove();
						recalculatePrice();
						updateCalendar();
					});
					typeIds.before(deleteMe);
					typeIds.before($('<div class="typeId font-c8 text-s">'+type.html()+'</div>'));
					for(var productKey in PRODUCTS[installationTypeId]) {
						if(!PRODUCTS[installationTypeId].hasOwnProperty(productKey)) continue;
						var iProduct = PRODUCTS[installationTypeId][productKey];
						products[iProduct.id] = iProduct;
					}
					var html = getGenericOption($.i18n.prop('p.customer.job.installation.create.form.product.product.chooseOne'));
					for(var productKey in products) {
						var product = products[productKey];
						if( product.id == $('#productInstallationId').val() ){
							continue;
						}
						html += "<option value='" + productKey +"' data-fixedprice='"+product.fixedResellerPricing+"' data-varprice='"+ product.variableResellerPricing +"' data-customprice='" + product.customPrice + "' data-subcategoryid='"+ product.installationType.subcategoryId +"' data-showamount='"+product.showAmount+"' data-minamount='"+ product.minAmount +"' data-maxamount='"+ product.maxAmount +"' data-visit='"+product.visit + "' data-withoutTax='" + product.withouttax + "' data-ondemand='"+product.onDemand+"' data-units='"+ product.unitName+"'>" + products[productKey].product.model + "</option>";
					}
					var productIds = parent.find('.product .productIds');
					productIds.html(html);
					if( productIds.children().length == 2 ){
						productIds.children(2).attr('selected', true);
						chooseAddOnProduct(productIds);
					}else{
						parent.find('.productIds').show();
					}
				}
				
				function chooseAddOnProduct(productIds){
					var parent = productIds.closest('.add-on');
					var type = parent.find('.typeIds :selected');
					var unitsValue = parent.find('.units .value');
					var unitsName = parent.find('.units .unit');
					var product = productIds.find(':selected');
					
					if( product.val() < 1 ){
						unitsValue.val('');
						recalculatePrice();
						return;
					}
					productIds.hide();
					if( productIds.children().length > 2 ){
//						only if there are options 
						productIds.before($('<span class="font-c8 text-s">'+product.html()+'</span>'));
					}
					if( product.data('showamount') ){
						unitsValue.val( product.data('minamount') );
						unitsValue.attr('maxvalue', product.data('maxamount'));
						unitsValue.attr('minvalue', product.data('minamount'));
						unitsName.html( product.data('units') );
						parent.find('.units').show();
					}else{
						unitsValue.val( product.data('minamount') );
						parent.find('.units').hide();
					}
					updateAddOnPrice(unitsValue);
					updateCalendar();
				}
				
				function updateAddOnPrice(unitsValue){
					var parent = unitsValue.closest('.add-on');
					var product = parent.find('.productIds :selected');
					var units = unitsValue.val();
					if( units < 1 ){
						parent.remove();
					}
					var minValue = product.data('minamount');
					var maxValue = product.data('maxamount');
					if( units <  minValue ){
						unitsValue.val( minValue );
					}else if( units > maxValue ){
						unitsValue.val(maxValue);
					}
					recalculatePrice();
				}
				
				function onInstallationTypeIdChange(){				
					loadBrands();				
					loadTerms();
				}
			};
			
			var bindInstallationTypeInFinder = function(){
				$(document).on("click",".team-box-btn div.ifix-btn-line-pink", function(){
					window.location.href = $(this).parent().data("url");
				});
			};
			
			return {
				initialize : initialize,
				bindInstallationTypeInFinder: bindInstallationTypeInFinder
			};
		})()
	});

}
catch (e) {
	debug.error("Marb namespace not present", e);
}